import { useState } from "react"
import { Box, Collapse, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { CopyableField } from "./copyable-field"

export function SPMetadataSection({ entityId, acsUrl, metadataUrl, children }) {
    const [open, setOpen] = useState(false)

    if (!entityId && !acsUrl && !metadataUrl) return null

    return (
        <Box sx={{ border: 1, borderColor: "divider", borderRadius: 1 }}>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 2,
                    py: 1,
                    cursor: "pointer",
                    userSelect: "none",
                }}
                onClick={() => setOpen((v) => !v)}
            >
                <Typography variant="subtitle2">Service Provider Details</Typography>
                <Tooltip title={open ? "Hide" : "Show service provider details"}>
                    <IconButton size="small">
                        <Iconify icon={open ? "mdi:chevron-up" : "mdi:chevron-down"} />
                    </IconButton>
                </Tooltip>
            </Box>
            <Collapse in={open}>
                <Box sx={{ px: 2, pb: 2 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Enter these values in your identity provider when registering the application.
                    </Typography>
                    <Stack spacing={2}>
                        <CopyableField
                            label="Entity ID (Identifier)"
                            value={entityId}
                            snackbarMessage="Entity ID copied"
                        />
                        <CopyableField
                            label="Reply URL (Assertion Consumer Service)"
                            value={acsUrl}
                            snackbarMessage="Reply URL copied"
                        />
                        <CopyableField
                            label="Federation Metadata URL"
                            value={metadataUrl}
                            snackbarMessage="Metadata URL copied"
                        />
                        {children}
                    </Stack>
                </Box>
            </Collapse>
        </Box>
    )
}
